<template>
  <h5 class="fw-light mb-2">Certidões:</h5>
  <p>
    <strong>
      Aprovou pelo Código
      {{
        measure.typeMeasure == 'T' || measure.typeMeasure == 'X'
          ? 'da Prestação de Contas'
          : 'de Rateio'
      }}?
    </strong>
    {{ measure.doValidadeAteg == 'F' ? 'Não' : 'Sim' }}
  </p>
  <p v-if="measure.ategPcTecId && measure.ategPcTecId !== 'null'">
    <strong>
      Código
      {{
        measure.typeMeasure == 'T' || measure.typeMeasure == 'X'
          ? 'da Prestação de Contas'
          : 'de Rateio'
      }}:
    </strong>
    {{ measure.ategPcTecId }}
  </p>
  <p v-if="measure.justifyCertificate">
    <strong>Justificativa: </strong>
    {{ measure.justifyCertificate }}
  </p>
</template>

<script>
export default {
  name: 'CertificationMeasure',

  props: {
    measure: {
      type: Object,
      required: true,
    },
  },
}
</script>
